// FAZ 3 — PENCERELER ARASI SÜRÜKLEYEREK TAŞIMA (hafif KÖPRÜ).
//
// NEDEN KÖPRÜ: sidebar listesi ve her yüzen pencere KENDİ `DragDropProvider`'ını
// kullanıyor (TasksPanel render yapısına dokunmamak için tek ortak sağlayıcıya
// TAŞIMIYORUZ). Sürükleme başlayınca durum global olarak yayınlanır; diğer
// pencereler ve sidebar bu duruma bakıp kendi "＋İÇİNE" noktalarını çizer.
// İsabet, YALNIZCA nokta elemanlarına filtrelenmiş `elementsFromPoint` ile
// belirlenir: bu liste yığın sırasına göre EN ÜSTTEN gelir, yani örtüşen
// katmanlarda en üstteki pencereye ait nokta kazanır (rastgelelik yok).
//
// Aynı listedeki eski sorun (sıralama önizlemesi kartları imlecin altından
// kaydırıyordu) burada YOK: hedef liste başka bir dnd manager'da olduğu için
// yer açma/önizleme uygulamaz, kartlar oynamaz.
import { useEffect, useState } from "react";

// TEK ANAHTAR: kapalıyken davranış eskisiyle BİREBİR aynı.
export const PENCERELER_ARASI_TASIMA_ACIK = true;

const OLAY = "sertex:cross-drag";
const NEST_SEC = "[data-nest-id]";

let durum = { aktif: false, gecersiz: null, kaynakKapsam: null };
let vurgulu = null;
let sonKonum = { x: null, y: null };

const yayinla = () => window.dispatchEvent(new CustomEvent(OLAY, { detail: { ...durum } }));

const vurguYaz = (el) => {
  if (vurgulu === el) return;
  if (vurgulu && vurgulu.getAttribute("data-nest-cross") === "true") {
    vurgulu.setAttribute("data-nest-active", "false");
    vurgulu.removeAttribute("data-nest-cross");
  }
  vurgulu = el;
  if (el) {
    el.setAttribute("data-nest-active", "true");
    el.setAttribute("data-nest-cross", "true");
  }
};

// İmlecin altındaki EN ÜST geçerli "İÇİNE" noktası.
export const enUstNokta = (x, y) => {
  if (x == null || y == null || typeof document.elementsFromPoint !== "function") return null;
  for (const n of document.elementsFromPoint(x, y)) {
    const nokta = n?.closest?.(NEST_SEC);
    if (!nokta) continue;
    const taskId = nokta.getAttribute("data-nest-id");
    const subId = nokta.getAttribute("data-nest-sub") || null;
    const anahtar = subId || taskId;
    if (durum.gecersiz?.has?.(anahtar)) continue;
    return { el: nokta, hedef: { taskId, subId } };
  }
  return null;
};

const izle = (e) => {
  sonKonum = { x: e.clientX, y: e.clientY };
  if (!durum.aktif) return;
  const bulunan = enUstNokta(e.clientX, e.clientY);
  vurguYaz(bulunan ? bulunan.el : null);
};

if (typeof window !== "undefined") {
  // Konum her zaman izlenir (bırakma anında imleç konumu gerekiyor).
  window.addEventListener("pointermove", (e) => { sonKonum = { x: e.clientX, y: e.clientY }; }, true);
  window.addEventListener("pointerdown", (e) => { sonKonum = { x: e.clientX, y: e.clientY }; }, true);
  window.addEventListener("touchmove", (e) => {
    const t = e.touches?.[0];
    if (t) izle({ clientX: t.clientX, clientY: t.clientY });
  }, true);
}

export const crossBaslat = (kaynakKapsam, gecersiz) => {
  if (!PENCERELER_ARASI_TASIMA_ACIK) return;
  durum = { aktif: true, gecersiz: gecersiz || null, kaynakKapsam };
  window.addEventListener("pointermove", izle, true);
  yayinla();
};

// Bırakma anında hedef: imlecin altındaki en üst nokta (yoksa null → çağıran
// taraf BUGÜNKÜ davranışını sürdürür, ör. kalemi kendi penceresine çıkarır).
export const crossHedef = (x = sonKonum.x, y = sonKonum.y) => {
  if (!PENCERELER_ARASI_TASIMA_ACIK || !durum.aktif) return null;
  const bulunan = enUstNokta(x, y);
  return bulunan ? bulunan.hedef : null;
};

export const crossBitir = () => {
  if (!PENCERELER_ARASI_TASIMA_ACIK) return;
  vurguYaz(null);
  durum = { aktif: false, gecersiz: null, kaynakKapsam: null };
  window.removeEventListener("pointermove", izle, true);
  yayinla();
};

export const crossKapsam = () => durum.kaynakKapsam;

// Bir dnd kapsamı KENDİSİ sürüklemiyorsa, başka kapsamda sürükleme varken
// noktalarını yine çizer (kullanıcı hedefi görebilsin).
export const useCrossNest = (kapsam, acik = true) => {
  const [dis, setDis] = useState({ aktif: false, gecersiz: null });
  useEffect(() => {
    if (!PENCERELER_ARASI_TASIMA_ACIK || !acik) return undefined;
    const el = (ev) => {
      const d = ev.detail || {};
      setDis(d.aktif && d.kaynakKapsam !== kapsam
        ? { aktif: true, gecersiz: d.gecersiz }
        : { aktif: false, gecersiz: null });
    };
    window.addEventListener(OLAY, el);
    return () => window.removeEventListener(OLAY, el);
  }, [kapsam, acik]);
  return dis;
};

// FAZ 4 (hızlı mod) — aynı yayın, React state'i olmadan dinlenir.
export const crossAbone = (fn) => {
  if (!PENCERELER_ARASI_TASIMA_ACIK) return () => {};
  const el = (ev) => fn(ev.detail || {});
  window.addEventListener(OLAY, el);
  return () => window.removeEventListener(OLAY, el);
};
